import { render, staticRenderFns } from "./relieve.vue?vue&type=template&id=099b93c8&scoped=true&"
import script from "./relieve.vue?vue&type=script&lang=js&"
export * from "./relieve.vue?vue&type=script&lang=js&"
import style0 from "./relieve.vue?vue&type=style&index=0&id=099b93c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b93c8",
  null
  
)

export default component.exports